export default __webpack_public_path__ + "static/media/miguel-lopes-12.e11c7597.jpg";